module.exports = __webpack_public_path__ + "img/content5.a9d56454.png";